import AddIcon from '@mui/icons-material/Add';
import DeleteIcon from '@mui/icons-material/Delete';
import {
  Box,
  FormControl,
  IconButton,
  InputLabel,
  MenuItem,
  Select,
  Typography
} from '@mui/material';
import Stack from '@mui/material/Stack';
import React from 'react';
import {SupportSlotAssignmentTypeEnum} from '../../../../model/support/slot/support-slot-assignment-type.enum';
import {SupportSlotCustomerAssignmentModel} from '../../../../model/support/slot/support-slot-customer-assignment.model';
import {SupportSlotDefinitionPreviewCustomersTabState} from '../state/support-slot-definition-preview-customers-tab-state';

type Props = {
  state: SupportSlotDefinitionPreviewCustomersTabState
}

export const SupportSlotDefinitionPreviewCustomersTab = ({state}: Props) => {
  const findOrganizationName = (planId: string) =>
    state.customers.find(it => it.planId === planId)?.organizationName ?? ''

  const availableCustomers = state.customers
    .filter(customer => !state.slotAssignments.map(it => it.planId).includes(customer.planId))

  const buildSlotAssignment = () => <Stack direction="row" spacing={1} alignItems="center" sx={{ mb: 1 }}>
    <FormControl size="small" sx={{ flex: 2 }}>
      <InputLabel>Klient</InputLabel>
      <Select
        value={state.selectedCustomer}
        label="Klient"
        onChange={e => state.setSelectedCustomer(e.target.value as string)}
        fullWidth
      >
        {availableCustomers.map(customer => (
          <MenuItem key={customer.planId} value={customer.planId}>
            {customer.organizationName}
          </MenuItem>
        ))}
      </Select>
    </FormControl>

    <FormControl size="small" sx={{ flex: 2 }}>
      <InputLabel>Typ</InputLabel>
      <Select
        value={state.selectedType}
        label="Typ"
        onChange={e => state.setSelectedType(e.target.value as SupportSlotAssignmentTypeEnum)}
        fullWidth
      >
        <MenuItem key={SupportSlotAssignmentTypeEnum.CONSULTATION} value={SupportSlotAssignmentTypeEnum.CONSULTATION}>{state.translate('support.slot.assignment.type.CONSULTATION')}</MenuItem>
        <MenuItem key={SupportSlotAssignmentTypeEnum.ANALYSIS} value={SupportSlotAssignmentTypeEnum.ANALYSIS}>{state.translate('support.slot.assignment.type.ANALYSIS')}</MenuItem>
        <MenuItem key={SupportSlotAssignmentTypeEnum.GENERAL} value={SupportSlotAssignmentTypeEnum.GENERAL}>{state.translate('support.slot.assignment.type.GENERAL')}</MenuItem>
      </Select>
    </FormControl>

    <IconButton
      color="primary"
      onClick={state.onCreateAssignmentPressed}
      disabled={!state.selectedCustomer || !state.setSelectedType}
    >
      <AddIcon />
    </IconButton>
  </Stack>

  const buildSlotAssignmentCard = (slotAssignment: SupportSlotCustomerAssignmentModel) => <Box
    key={slotAssignment.id}
    sx={{
      display: 'flex',
      justifyContent: 'space-between',
      alignItems: 'center',
      p: 1,
      border: '1px solid',
      borderColor: 'divider',
      borderRadius: 1.2,
    }}
  >
    <Box>
      <Typography sx={{ fontWeight: 500, fontSize: '0.95rem' }}>
        {findOrganizationName(slotAssignment.planId)}
      </Typography>
      <Typography variant="body2" color="text.secondary" sx={{ fontSize: '0.8rem' }}>
        Typ: {state.translate(`support.slot.assignment.type.${slotAssignment.assignmentType}`)}
      </Typography>
    </Box>
    <IconButton color="error" size="small" onClick={async () => await state.onAssignmentDeletePressed(slotAssignment.id, slotAssignment.version)}>
      <DeleteIcon fontSize="small" />
    </IconButton>
  </Box>

  return (
    <Box sx={{ mt: 0, pt: 0, mb: 4 }}>
      {buildSlotAssignment()}
      <Stack spacing={1}>
        {state.slotAssignments.map(it => buildSlotAssignmentCard(it))}
      </Stack>
    </Box>
  );
};